import DOMPurify from 'dompurify';
import { decodeHtmlEntities } from '~/lib/decodeHtmlEntities';

/**
 * Strip all HTML tags via DOMPurify.
 * Prefer this over `/<[^>]*>/g` — that pattern is incomplete for malformed/nested tags.
 */
export const stripHtmlTags = (html: string | undefined | null): string => {
  if (!html) return '';
  return DOMPurify.sanitize(html, { ALLOWED_TAGS: [] });
};

/** Sanitize HTML before `dangerouslySetInnerHTML` / HTML sinks. */
export const sanitizeHtmlForDisplay = (
  html: string | undefined | null
): string => {
  if (!html) return '';
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
};

export const stripHtml = (html: string | undefined): string => {
  if (!html) return '';
  const normalized = html
    .replace(/\r?\n|\r/g, '')
    .replace(/<br\b[^>]*\/?>/gi, '\n')
    .replace(/&nbsp;|&#0*160;|&#x0*a0;/gi, ' ');
  const textOnly = stripHtmlTags(normalized);
  return decodeHtmlEntities(textOnly).trimEnd();
};

export const sanitizeBodyForSave = (text: string): string => {
  if (!text) return '';
  const esc = (s: string) =>
    s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  return esc(text).replace(/\r?\n|\r/g, '<br>');
};

export const sanitizeTitleForSave = (title: string): string => {
  if (!title) return '';
  return title.trim();
};
